var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bar",staticClass:"barGaugeBackground"},[_c('div',{staticClass:"barGaugeForeground",style:({width: _vm.percentileBarWidth})}),_vm._v(" "),_c('div',{staticClass:"barLabel"},[_vm._v("\n    "+_vm._s(_vm.percentileLabel)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }